(function () {
  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-IN',
        {
          style: 'currency',
          currency: currency || 'INR'
        }
      ).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function getVariantConfig(selector, variantId) {
    if (!selector || !variantId) return null;

    return Array.from(
      selector.querySelectorAll('[data-smart-pack-variant]')
    ).find(function (node) {
      return String(node.dataset.variantId) === String(variantId);
    }) || null;
  }

  function updateButtonForVariant(selector, button, config) {
    const qty = parseInt(button.dataset.qty || '1', 10);
    const basePrice = parseInt(config.dataset.basePrice || '0', 10);
    const inventoryQty = parseInt(config.dataset.inventoryQty || '0', 10);
    const unlimitedInventory = config.dataset.unlimitedInventory === 'true';

    let unitPrice = basePrice;

    if (qty > 1) {
      unitPrice = parseInt(
        config.getAttribute('data-pack-' + qty + '-unit-price') || '0',
        10
      );
    }

    if (!unitPrice || unitPrice <= 0) {
      button.hidden = true;
      button.disabled = true;
      button.classList.remove('is-active');
      return;
    }

    const totalPrice = unitPrice * qty;
    const unitSingular = selector.dataset.unitSingular || 'Can';
    const currency = selector.dataset.currency || 'INR';

    button.hidden = false;
    button.disabled = !unlimitedInventory && inventoryQty < qty;
    button.dataset.unitPrice = String(unitPrice);
    button.dataset.packPrice = String(totalPrice);

    const unitPriceEl = button.querySelector('[data-smart-pack-button-unit]');
    const totalPriceEl = button.querySelector('[data-smart-pack-button-total]');

    if (unitPriceEl) {
      unitPriceEl.textContent =
        formatMoney(unitPrice, currency) +
        ' / ' +
        unitSingular.toLowerCase();
    }

    if (totalPriceEl) {
      totalPriceEl.textContent =
        formatMoney(totalPrice, currency) +
        ' total';
    }
  }

  function updateSmartPack(selector, button) {
    if (!selector || !button || button.disabled || button.hidden) return;

    const qty = parseInt(button.dataset.qty || '1', 10);
    const packPrice = parseInt(button.dataset.packPrice || '0', 10);
    const unitPrice = parseInt(button.dataset.unitPrice || '0', 10);
    const basePrice = parseInt(selector.dataset.basePrice || '0', 10);
    const comparePrice = parseInt(selector.dataset.comparePrice || '0', 10);

    if (!qty || !packPrice || !unitPrice || !basePrice) return;

    const currency = selector.dataset.currency || 'INR';
    const unitSingular = selector.dataset.unitSingular || 'Can';
    const unitLabel = unitSingular.toLowerCase();

    selector
      .querySelectorAll('[data-smart-pack-button]')
      .forEach(function (item) {
        item.classList.remove('is-active');
      });

    button.classList.add('is-active');
    selector.dataset.selectedPackQty = String(qty);

    const quantityInput = selector.querySelector('[data-smart-pack-quantity]');

    if (quantityInput) {
      quantityInput.value = String(qty);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Use compare-at price as the savings reference whenever it is a
    // genuine higher price. Otherwise fall back to the regular variant price.
    const referenceUnitPrice =
      comparePrice > basePrice ? comparePrice : basePrice;
    const originalTotal = referenceUnitPrice * qty;
    const savingAmount = Math.max(0, originalTotal - packPrice);
    const savingPercent =
      originalTotal > 0
        ? Math.round((savingAmount / originalTotal) * 100)
        : 0;

    const originalTotalEl = selector.querySelector(
      '[data-smart-pack-original-total]'
    );
    const activeTotalEl = selector.querySelector(
      '[data-smart-pack-active-total]'
    );
    const savingEl = selector.querySelector(
      '[data-smart-pack-saving]'
    );
    const originalPerUnitEl = selector.querySelector(
      '[data-smart-pack-original-per-can]'
    );
    const activePerUnitEl = selector.querySelector(
      '[data-smart-pack-active-per-can]'
    );

    if (originalTotalEl) {
      originalTotalEl.textContent =
        savingAmount > 0
          ? formatMoney(originalTotal, currency)
          : '';
    }

    if (activeTotalEl) {
      activeTotalEl.textContent = formatMoney(packPrice, currency);
    }

    if (savingEl) {
      savingEl.textContent =
        savingPercent > 0 ? 'Save ' + savingPercent + '%' : '';
    }

    if (originalPerUnitEl) {
      originalPerUnitEl.textContent =
        savingAmount > 0
          ? formatMoney(referenceUnitPrice, currency) + ' per ' + unitLabel
          : '';
    }

    if (activePerUnitEl) {
      activePerUnitEl.textContent =
        formatMoney(unitPrice, currency) + ' per ' + unitLabel;
    }
  }

  function applyVariant(selector, variantId) {
    const config = getVariantConfig(selector, variantId);
    if (!config) return;

    selector.dataset.basePrice = config.dataset.basePrice || '0';
    selector.dataset.comparePrice = config.dataset.comparePrice || '0';
    selector.dataset.currentVariantId = String(variantId);

    const variantInput = selector.querySelector('[data-smart-pack-variant-input]');
    if (variantInput) {
      variantInput.value = String(variantId);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    selector
      .querySelectorAll('[data-smart-pack-strength-button]')
      .forEach(function (button) {
        button.classList.toggle(
          'is-active',
          String(button.dataset.variantId) === String(variantId)
        );
      });

    const variantAvailable = config.dataset.available !== 'false';
    const addButton = selector.querySelector('[data-smart-pack-add-button]');
    const addLabel = selector.querySelector('[data-smart-pack-add-label]');

    if (addButton) {
      addButton.disabled = !variantAvailable;
    }

    if (addLabel) {
      addLabel.textContent = variantAvailable ? 'Add to cart' : 'Sold out';
    }

    selector
      .querySelectorAll('[data-smart-pack-button]')
      .forEach(function (button) {
        updateButtonForVariant(selector, button, config);
      });

    const preferredQty = parseInt(
      selector.dataset.selectedPackQty || '1',
      10
    );

    let preferredButton = selector.querySelector(
      '[data-smart-pack-button][data-qty="' + preferredQty + '"]'
    );

    if (
      !preferredButton ||
      preferredButton.hidden ||
      preferredButton.disabled
    ) {
      preferredButton = selector.querySelector(
        '[data-smart-pack-button][data-qty="1"]:not([hidden]):not(:disabled)'
      );
    }

    if (!preferredButton) {
      preferredButton = selector.querySelector(
        '[data-smart-pack-button]:not([hidden]):not(:disabled)'
      );
    }

    if (preferredButton) {
      updateSmartPack(selector, preferredButton);
    }
  }

  function initializeSelector(selector) {
    if (!selector) return;

    const variantId =
      selector.dataset.currentVariantId ||
      selector.dataset.initialVariantId;

    if (variantId) {
      applyVariant(selector, variantId);
    }
  }

  function initializeSmartPackPricing(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope
      .querySelectorAll('[data-smart-pack-selector]')
      .forEach(initializeSelector);
  }

  document.addEventListener('click', function (event) {
    const strengthButton = event.target.closest('[data-smart-pack-strength-button]');
    if (!strengthButton) return;

    event.preventDefault();
    event.stopPropagation();

    const selector = strengthButton.closest('[data-smart-pack-selector]');
    const variantId = strengthButton.dataset.variantId;

    if (!selector || !variantId || strengthButton.disabled) return;

    applyVariant(selector, variantId);
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-smart-pack-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    updateSmartPack(
      button.closest('[data-smart-pack-selector]'),
      button
    );
  });

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variantId = event && event.data && event.data.variant
        ? event.data.variant.id
        : null;

      if (!variantId) return;

      document
        .querySelectorAll('[data-smart-pack-selector]')
        .forEach(function (selector) {
          if (getVariantConfig(selector, variantId)) {
            applyVariant(selector, variantId);
          }
        });
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects')) return;

    window.setTimeout(function () {
      document
        .querySelectorAll('[data-smart-pack-selector]')
        .forEach(function (selector) {
          const form = selector.closest('form');
          const variantInput = form
            ? form.querySelector('input[name="id"]')
            : null;

          if (variantInput && variantInput.value) {
            applyVariant(selector, variantInput.value);
          }
        });
    }, 350);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeSmartPackPricing(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSmartPackPricing(document);
    });
  } else {
    initializeSmartPackPricing(document);
  }
})();
